module.exports = __webpack_public_path__ + "static/media/Bird feeding.7dcb68fe.jpg";